import SwiperCarousel from '../utils/swiper-carousel';

export default (element) => {
  const el = element.querySelector('[data-collection-carousel]');
  if (!el) return;

  const currentCollectionHandle = el.dataset.handle;
  let currentCollectionIndex = 0;
  el.querySelectorAll('.swiper-wrapper > .swiper-slide').forEach(
    (child, index) => {
      if (child.dataset.slideHandle === currentCollectionHandle) {
        currentCollectionIndex = index;
      }
    },
  );
  const slidesCount = el.querySelectorAll(
    '.swiper-wrapper > .swiper-slide',
  ).length;
  const isMelanie = document.querySelector('.theme-ml');
  if (slidesCount <= 8 && isMelanie) {
    el.querySelector('.swiper-wrapper').style.maxWidth = `${
      213 * slidesCount - 8
    }px`;
  }
  const init = () => {
    // eslint-disable-next-line no-new
    const collectionSlider = new SwiperCarousel(el, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      allowTouchMove: true,
      freeMode: true,
      navigation: {
        nextEl: '.carousel-button-next',
        prevEl: '.carousel-button-prev',
      },
      mousewheel: {
        forceToAxis: true,
      },
    });

    collectionSlider.swiper.slideTo(currentCollectionIndex, 0, false);
  };

  init();
};
